import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

import SeedMetadataContext from './SeedMetadataContext';
import * as selectors from './selectors';

const SeedMetadataProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <SeedMetadataContext.Provider value={{ actions, state, selectors }}>
      {children}
    </SeedMetadataContext.Provider>
  );
};

export default SeedMetadataProvider;
